import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../scss/qr-style.scss';

import Brand from './style-components/Brand';
import Color from './style-components/Color';
import QRSize from './style-components/QRSize';
import Style from './style-components/Style';
import Text from './style-components/Text';

interface MenuType {
  id: number;
  title: string;
  component: JSX.Element;
}

interface QrStyleProperties {
  qrValues: any;
  setQrValues: React.Dispatch<React.SetStateAction<any>>;
}

/**
 * QR Style Component
 * @param {QrStyleProperties} properties - Component properties
 * @param {any} properties.qrValues - QR configuration values state
 * @param {React.Dispatch<React.SetStateAction<any>>} properties.setQrValues - State updater for QR configuration values
 * @returns {JSX.Element} QR style component layout
 */
function QrStyle({ qrValues, setQrValues }: QrStyleProperties): JSX.Element {
  const { t } = useTranslation('qrCode');
  const [menu, setMenu] = useState<number>(0);

  const components: MenuType[] = [
    {
      id: 1,
      title: t('styles'),
      component: <Style setQrValues={setQrValues} />,
    },
    {
      id: 2,
      title: t('color'),
      component: <Color qrValues={qrValues} setQrValues={setQrValues} />,
    },
    {
      id: 3,
      title: t('text'),
      component: <Text qrValues={qrValues} setQrValues={setQrValues} />,
    },
    {
      id: 4,
      title: t('brand'),
      component: <Brand qrValues={qrValues} setQrValues={setQrValues} />,
    },
    {
      id: 5,
      title: t('qrSize'),
      component: <QRSize qrValues={qrValues} setQrValues={setQrValues} />,
    },
  ];

  /**
   * Function For Updating Component to State
   * @param {number} id - Submenu item ID
   */
  const handleSelect = (id: number) => {
    setMenu(id);
  };

  return (
    <div className="qr-style-wrap">
      {components.map((comp) => (
        <React.Fragment key={comp.id}>
          <div className="qr-menu">
            <p role="presentation" className="menu" onClick={() => handleSelect(comp.id)}>
              {comp.title}
            </p>
          </div>
          <div>
            {menu === comp.id ? <div className="qr-menu-comp">{comp.component}</div> : null}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default QrStyle;
